import { useTranslation } from '../../../i18n/i18n';
import { UiContainer } from '../../../state/ui';
import { filter_icon, Icon } from '../../Icon/Icon';
import './FilterButton.css';
import { FilterContainer } from '../../../state/filters';

type FilterButtonProps = {};

export const FilterButton = ({}: FilterButtonProps) => {
	const t = useTranslation().filtering;
	const ui = UiContainer.useContainer();
	const { getNumOfAppliedFilters } = FilterContainer.useContainer();

	const handleOnClick = (_e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		ui.toggleFilterPanel();
	};

	return (
		<div className="filter-button" onClick={(e) => handleOnClick(e)}>
			<div className="filter-content">
				<div className="filter-text">{t.filterSingular}</div>
				<div className="filter-icon">
					{getNumOfAppliedFilters() > 0 ? (
						<div className="filter-counter">
							<span className="filter-counter-text">{getNumOfAppliedFilters()}</span>
						</div>
					) : (
						<Icon shape={filter_icon} />
					)}
				</div>
			</div>
		</div>
	);
};
